import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IDynamicElement } from '../../_shared/models/dynamic/dynamic-element.model';
import { IFormElementChild } from '../../_shared/models/form/form-element-child.model';
import { v4 as uuidv4 } from 'uuid';

@Directive({
    standalone: true,
})
export abstract class FormElementBase implements IDynamicElement {
    @Input() name = '';
    @Input() label = '';
    @Input() form: FormGroup = new FormGroup({});
    @Input() formFieldDependencies?: IFormElementChild[];
    @Input() validation: string[] = [];
    @Input() identifier = '';

    @Output() emitter: EventEmitter<void> = new EventEmitter<void>();

    id = uuidv4();

    get control(): FormControl {
        return this.form.get(this.name) as FormControl;
    }
}
